import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './benefit-templates.loaders';
import { converters } from './benefit-templates.converters';
import { BenefitTemplatesFilters } from './benefit-templates.types';

export const benefitTemplatesKeys = queryKeyFactory('benefit-templates');

export const useBenefitTemplates = (
  filters: Partial<BenefitTemplatesFilters> = {},
) => {
  return useQuery({
    queryKey: benefitTemplatesKeys.list(filters),
    queryFn: () => loaders.getBenefitTemplates({ filters }),
    select: converters.getBenefitTemplates,
  });
};
